import * as React from 'react';

import classNames from 'classnames';
import type { LocationDescriptorObject } from 'history';
import { some } from 'lodash';

import { simplifyQueryValue } from 'js/lib/queryUtils';

import { TeamsContext } from 'bundles/teams-v2/components/TeamsContainer';
import TeamsPurchaseCheckoutSummary from 'bundles/teams-v2/components/TeamsPurchaseCheckoutSummary';
import TeamsPurchaseCheckoutSummaryMobile from 'bundles/teams-v2/components/TeamsPurchaseCheckoutSummaryMobile';

import 'css!./__styles__/TeamsPurchaseSummary';

export type Props = {
  query: LocationDescriptorObject['query'];
  mobileOnly?: boolean;
  path?: string;
  className?: string;
};

export const TeamsPurchaseSummary: React.FC<Props> = (props) => {
  const { query, mobileOnly, path, className } = props;

  const { learnerCount, billingType, productPrice, defaultProductPrice, promotion, freeTrial, isPromotionEligible } =
    React.useContext(TeamsContext);

  const _defaultProductPrice = defaultProductPrice?.[0];
  const _productPrice = productPrice?.[0];

  const discountPercentage = isPromotionEligible ? _productPrice?.discountPercent || promotion?.discountPercent : 0;
  const discountAmount = _productPrice?.actualLocalDiscountedAmount;
  // TODO: I believe this is incorrect but will work until i18n is added
  const originalPrice = _productPrice?.rawAmountTotal;
  const discountedPrice = _productPrice?.actualLocalAmountTotal;

  const organizationName = query && simplifyQueryValue(query.organizationName);

  // TODO: These values are probably inappropriate
  const total = _productPrice?.actualLocalAmountTotal;
  const todaysTotal = _productPrice?.actualLocalAmountDueToday;

  const defaultCurrencyCode = _defaultProductPrice?.currencyCode || 'USD';
  const currencyCode = _productPrice?.currencyCode || defaultCurrencyCode;
  const defaultUnitPrice = _defaultProductPrice?.unitPrice || '399.00';
  const unitPrice = _productPrice?.unitPrice || defaultUnitPrice;
  const loading = some([currencyCode, total, todaysTotal, unitPrice], (val) => val === undefined);

  return (
    <div
      className={classNames(
        'rc-TeamsPurchaseSummary vertical-box align-items-vertical-center',
        'rc-TeamsPurchaseSummary--redesign',
        className,
        { mobileOnly },
        { desktopOnly: !mobileOnly }
      )}
    >
      {mobileOnly && (
        <TeamsPurchaseCheckoutSummaryMobile
          total={total}
          isFreeTrial={freeTrial}
          todaysTotal={todaysTotal}
          organizationName={organizationName}
          learnerCount={learnerCount}
          billingType={billingType}
          unitPrice={unitPrice}
          showEditLink={path === 'billing'}
          loading={loading}
          currency={currencyCode}
          discountPercentage={discountPercentage}
          discountAmount={discountAmount}
          originalPrice={originalPrice}
          discountedPrice={discountedPrice}
        />
      )}
      {!mobileOnly && (
        <TeamsPurchaseCheckoutSummary
          total={total}
          isFreeTrial={freeTrial}
          todaysTotal={todaysTotal}
          organizationName={organizationName}
          learnerCount={learnerCount}
          billingType={billingType}
          unitPrice={unitPrice}
          showEditLink={path === 'billing'}
          loading={loading}
          currency={currencyCode}
          discountPercentage={discountPercentage}
          discountAmount={discountAmount}
          originalPrice={originalPrice}
          discountedPrice={discountedPrice}
        />
      )}
    </div>
  );
};

export default TeamsPurchaseSummary;
